<template>
    <div>
        ...
    </div>
</template>

<script>
export default {
    mounted() { 
        this.$store.commit("setBreadcrumb", [
            { name: 'Laboratório', path: "/laboratorio/visao" },
            { name: 'Visão Geral' }
        ]);
    }
}
</script>